import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Tutor from './pages/Tutor';
import Student from './pages/Student';
import SuperAdmin from './pages/SuperAdmin';
import Inquiry from './pages/Inquiry';
import API from './api';
import { registerPushSubscription } from './push';

function PrivateRoute() {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Always verify the session from the server — prevents localStorage role spoofing
    API.get('/auth/me')
      .then(r => {
        const serverRole = r.data.role;
        localStorage.setItem('role', serverRole);
        localStorage.setItem('name', r.data.name || '');
        localStorage.setItem('user_id', String(r.data.id || ''));
        setRole(serverRole);
        // Register push subscription after successful auth (best-effort)
        registerPushSubscription();
      })
      .catch(() => {
        localStorage.clear();
        setRole('');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', fontFamily:"'Plus Jakarta Sans', sans-serif", color:'#64748b', fontSize:15 }}>
      Loading…
    </div>
  );

  if (role === 'super_admin') return <SuperAdmin />;
  if (role === 'admin')       return <Admin />;
  if (role === 'tutor')       return <Tutor />;
  if (role === 'student')     return <Student />;
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Inquiry />} />
        <Route path="/*"    element={<PrivateRoute />} />
      </Routes>
    </BrowserRouter>
  );
}
